import { Avatar, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import type { Comment } from '../../../../../pageContext';

import { useCommentHeader } from './hooks/useCommentHeader';

type Props = {
	comment: Comment;
};

export function CommentHeader({ comment }: Props) {
	const {
		// data: { author, authorUrl, authorAvatar, dateRelative },
		data: { author, authorAvatar, dateRelative },
	} = useCommentHeader(comment);

	return (
		<div className="flex items-center">
			<Avatar alt="avatar" size="small" src={authorAvatar} />
			<Text as="p" className="ml-2">
				<Text as="span">
					<b>{author}</b>{' '}
					<Translate value="corgi.petition.starter_dashboard.petition_comments.comments_list.commented_by" />{' '}
					{dateRelative}
				</Text>
			</Text>
		</div>
	);
}
